import Vue from 'vue';

export default new Vue({
  data: {},
  methods: {
    async getStats() {
      return await this.$http.get('/api/stats').then(({ data }) => data);
    },
  }
});